<style lang="less" scoped>
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.table {border-collapse: collapse;width: 100%;}
.select1 .el-input__inner {width: 150px;}
.ziduanKey .el-input__inner {width: 340px;}
.level .el-input__inner {width: 150px;}
.sort .el-input__inner {width: 150px;}
.date-picker.el-input {width: 200px;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;margin-bottom: 40px;}
.btnbox .btn {margin-top: 10px;margin-left: 15px;}
.recycling_box .delete {margin-left: 40px;}
.btnbox .level {margin-left: 10px;}
.el-form-item {float: left;margin-bottom: 0px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
.tr1 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.tr2 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.select1 /deep/ .el-input__inner {width: 150px;}
.ziduanKey /deep/ .el-input__inner {width: 340px;}
.level /deep/ .el-input__inner {width: 150px;}
.sort /deep/ .el-input__inner {width: 150px;}
.count /deep/ .el-input__inner {width: 50px;}
.pagination{margin-bottom: 40px;}
.dialog-footer{margin-top: 50px;}
/deep/ .el-checkbox__inner{margin-left: -140px;}
/deep/ .el-checkbox__label{margin-left: -5px;}
.btn {margin: 0px auto;height: 60px;z-index: 19999;}
.btn .el-button {height: 40px;margin: 10px auto;}
.btn {position: fixed;bottom: 0;left: 0;right: 0;height: 60px;background: #f8f4f4;margin-left: 240px;background-color: #dff0d8;}
.el-tablebox {margin-bottom: 60px;}
</style>

<template>
  <div class="second" id="second">
    <div class="dmkclb—_box second">
      <div class="el-tablebox">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          stripe
          border
          :cell-style="{ textAlign: 'center' }"
          :header-cell-style="{background: '#F5F5F5',color: '#606266',textAlign: 'center',}">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="no" label="账号"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="sign_state" label="完整性校验"></el-table-column>
          <el-table-column label="性别">
            <template slot-scope="scope">{{ scope.row.gender | gender() }}</template>
          </el-table-column>
          <el-table-column prop="id" label="操作" width="400">
            <template slot-scope="scope">
               <el-button type="success" @click="resetPsw(99, 13,scope.row)">重置密码</el-button>
               <el-button type="primary" @click="relation(scope.row)">关联</el-button>
               <el-button type="warning" @click="updatafn(scope.row)">修改</el-button>
               <el-button type="danger" @click="deletefn(99, 13,scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btn">
        <el-button type="success" @click="addfn()">添加</el-button>
      </div>
    </div>
    <div>
      <el-dialog title="用户角色关联" :visible.sync="dialogFormVisible">
        <template>
          <el-transfer v-model="value" :props="{key: 'id',label: 'name'}" :data="dataRole" :titles="['待分配', '已分配']" @change="handleChange"></el-transfer>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import filters from '../method/filter'
import method from '../method/methods'
import {mapState} from 'vuex'
export default {
  mixins: [filters, method],
  data()
  {
    return {
      value: [],
      form:
      {
        userid: '',
        roleid: '',
        sys: '11'
      },
      pageSize: 20,
      currentPage: 1,
      countSum: null,
      //分类数据
      classifydata: [],
      //列表数据
      tableData: [],
      dialogFormVisible: false,
      formLabelWidth: '200px',
      dataRole: [],
      dataUser: [],
      usersid: '',
      roleArr: [],
      userMsg: {}
    }
  },
  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID,
      IsLb: state => state.IsLb
    })
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        window.public.getFldvalue(nval, 'catid').then((ret) =>
        {
          this.classifydata = []
          ret.forEach((item) => this.classifydata.push({ value: item.id, label: item.dispc }))
        })
      },
      immediate: true
    },
    IsLb:
    {
      handler(nval, oval)
      {
        if (nval === '1')
          this.getList()
        this.$store.commit('onIsLb', '0')
      },
      deep: true,
      immediate: true
    }
  },
  filters:
  {
    gender: function(num)
    {
      switch (num)
      {
      case 0: return '男'
      case 1: return '女'
      }
    }
  },
  created()
  {
    this.getList()
    this.getUser()
    this.getRole()
  },
  methods: {
    relation(row)
    {
      this.dialogFormVisible = true
      this.usersid = row.id
      let paras = {cmd: 'query', _major: 99, _minor: 16, _exp: `userid = ${this.usersid}`}
      window.post.getPost(paras).then((ret) =>
      {
        this.roleArr = []
        ret.forEach(data =>
        {
          this.roleArr.push(data.roleid)
        })
        this.value = this.roleArr
      })
    },
    getGenerateData()
    {
      const data = []
      for (let i = 1; i <= this.dataRole.length; i++)
      {
        data.push({
          value: i,
          desc: `${i}`
        })
      }
      return data
    },
    //获取用户数据
    getUser()
    {
      let paras = {cmd: 'query', _major: 99, _minor: 13, _exp: 'id>1',  orderby: 'id DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        console.log(ret)
        this.dateUser = []
        ret.forEach((item) =>
        {
          this.dateUser.push({
            id: item.id,
            name: item.name,
            sign_state: item.sign_state
          })
        })
      })
    },
    //获取角色数据
    getRole()
    {
      let paras = {cmd: 'query', _major: 99, _minor: 15, _exp: 'id>0',  orderby: 'id DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.dataRole = []
        ret.forEach((item) =>
        {
          this.dataRole.push({
            id: item.id,
            name: item.name
          })
        })
      })
    },
    //获取数据
    getList()
    {
      let paras = {cmd: 'query', _major: 99, _minor: 13, _exp: 'id>1 and ismember = 0',  orderby: 'id DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.tableData = []
        ret.forEach((item) =>
        {
          this.tableData.push({
            id: item.id,
            name: item.name,
            no: item.no,
            gender: item.gender,
            sign_state: item.sign_state,
            rname: ''
          })
        })
      })
      let paras1 = {cmd: 'queryUnion', _major: 99, _minor: 13, tables: 'A;B:99,15;C:99,16', cols: 'A:*;B:name as rname', _exp: 'A.id>0 and C.userid=A.id and C.roleid=B.id'}
      window.post.getPost(paras1).then((ret) =>
      {
        for (let i = 0; i < ret.length; i++)
        {
          for (let j = 0; j < this.tableData.length; j++)
          {
            if (ret[i].name === this.tableData[j].name)
              this.tableData[j].rname = ret[i].rname
          }
        }
      })
    },
    //点击修改
    updatafn(row)
    {
      this.$router.push({path: '/UserUpdate', query: {id: row.id}})
    },
    //点击审核
    look(row)
    {
      this.$router.push({path: '/KyzhLook', query: {id: row.id}})
    },
    addUserrole()
    {
      let obj = {
        cmd: 'add',
        _major: 99,
        _minor: 16,
        retAtt: 1,
        userid: this.form.userid,
        roleid: this.form.roleid,
        sys: this.form.sys
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '关联失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '关联成功', type: 'success', customClass: 'mzindex'})
          this.$emit('removeTab')
          this.$store.commit('onIsLb', '1')
        }
      })
    },
    handleChange()
    {
      let paras1 = {
        cmd: 'delUserRole',
        userid: `${this.usersid}`,
        sys: 11
      }
      window.post.getIdentitySvr(paras1)
      //绑定角色
      let userdata = []
      this.value.forEach(e =>
      {
        userdata.push({sys: 11, userid: `${this.usersid}`, roleid: e})
      })
      let obj = {
        cmd: 'adds',
        _major: 99,
        _minor: 16,
        json: JSON.stringify(userdata)
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '设置失败', type: 'error', customClass: 'mzindex'})
        else
          this.$message({message: '设置成功', type: 'success', customClass: 'mzindex'})
      })
    },
    /**
     * 彻底删除--单
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletefn(major, minor, row)
    {
      let that = this
      window.public.deletefn(major, minor, row, that)
    },
    //子组件调用新增添加Tabs
    addfn()
    {
      this.$emit('addTab')
    },
    //————列表页的公共方法————
    //搜索
    search()
    {
      this.getList()
      this.handleSizeChange(this.form.count)
    },
    //重置搜索条件
    cancelfnBtn()
    {
      let str = 'count'
      let that = this
      window.public.cancelfnBtn(str, that)
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    },
    resetPsw(major, minor, row)
    {
      console.log(major, minor, row)
      let paras = {cmd: 'reSetPsw', userid: row.id}
      window.post.getLogin(paras).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '重置失败', type: 'error'})
        else
        
          this.$message({message: '重置成功', type: 'success'})
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/assembly/UserLb.vue